import { render, staticRenderFns } from "./CampaignItem.vue?vue&type=template&id=6765b5ec&"
import script from "./CampaignItem.vue?vue&type=script&lang=js&"
export * from "./CampaignItem.vue?vue&type=script&lang=js&"
import style0 from "./CampaignItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports